import axios from 'axios';
import { DateTime } from 'luxon';
import * as Sentry from '@sentry/react';
import { useState } from 'react';

export const isEmpty = val => {
  if (val === undefined) return true;
  if (
    typeof val == 'function' ||
    typeof val == 'number' ||
    typeof val == 'boolean' ||
    Object.prototype.toString.call(val) === '[object Date]'
  )
    return false;
  if (val == null || val.length === 0)
    // null or 0 length array
    return true;
  if (typeof val == 'object') {
    // empty object
    var r = true;
    for (var f in val) r = false;
    return r;
  }

  return false;
};

export const normalizeReferralSource = source =>
  source === 'md' ? 'md' : 'self';

export const getArrayIdFromObject = (arr, key, value) => {
  console.log(key, value);
  return arr.findIndex(obj => obj[key] == value);
};

export function calculateAge(birthDateString) {
  if (!birthDateString) return null;

  const today = new Date();

  // Force birthDate to local time to avoid UTC shift
  const parts = birthDateString.split('-');
  const birthDate = new Date(
    Number(parts[0]),
    Number(parts[1]) - 1, // month is 0-based
    Number(parts[2])
  );

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export function calculateYearandMonth(dob) {
  if (!dob) return { years: null, months: null };

  const today = new Date();

  // Force birthDate to local time to avoid UTC shift
  const parts = String(dob).split('-');
  const birthDate = new Date(
    Number(parts[0]),
    Number(parts[1]) - 1, // month is 0-based
    Number(parts[2])
  );

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();

  // Not yet reached this month's day-of-month, so the current month hasn't completed
  if (today.getDate() < birthDate.getDate()) {
    months--;
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months };
}

// NCP eligibility is age 18–39, Valid OHIP, not Out of Province, Lower-Intervention (NCP) or Fertility Check
// NCP / Fertility Check ages 40–42 (same OHIP/location rules) route to VR instead of NCP
// EF eligibility is age less than 42 and 6 month and at least 18, Valid OHIP, not Out of Province, Fertility Perservation
// VR eligibility is age less than 43 (42 is max) and at least 18, Valid OHIP, not Out of Province, Try to Conveive -> IVF (or NCP/Fertility Check ages 40–42)
// Learn More eligibility is age less than 43 (42 is max) and at least 18, Learn More and Other
// Normalize the intake selection into a single treatment "path". The new
// intake form (/intake_new) provides `treatment_interest`; the legacy form
// (/intake) provides `interest` / `fertility_treatment`, which we fall back to.
// Returns one of: 'ivf' | 'ncp' | 'fertility_check' | 'egg_freezing' |
// 'embryo_freezing' | 'learn_more' | null.
export function getTreatmentPath(source = {}) {
  const treatmentInterest = source.treatment_interest;
  if (treatmentInterest) {
    switch (treatmentInterest) {
      case 'ivf':
        return 'ivf';
      case 'lower_intervention':
        return 'ncp';
      case 'fertility_check':
        return 'fertility_check';
      case 'freeze_eggs':
        return 'egg_freezing';
      case 'freeze_embryos':
        return 'embryo_freezing';
      // Both "Not Sure" answers (trying to get pregnant Yes or No) are the
      // Learn More path. There is no separate "Other" path on the new form.
      case 'not_sure':
        return 'learn_more';
      default:
        return null;
    }
  }

  // Legacy /intake fallback based on interest / fertility_treatment.
  const interest = source.interest?.toLowerCase() ?? '';
  const fertilityTreatment = source.fertility_treatment?.toLowerCase() ?? '';
  if (fertilityTreatment.includes('ivf')) return 'ivf';
  if (fertilityTreatment === 'ncp') return 'ncp';
  if (interest.includes('fertility check')) return 'fertility_check';
  if (fertilityTreatment.includes('embryo')) return 'embryo_freezing';
  if (fertilityTreatment.includes('egg') || interest.includes('fertility preservation'))
    return 'egg_freezing';
  if (interest.includes('learn more') || fertilityTreatment.includes('other'))
    return 'learn_more';
  return null;
}

export function readyTobookEligibity(
  age,
  ohip,
  location,
  interest,
  fertility_treatment,
  date_of_birth,
  referral_source,
  treatment_interest
) {
  let eligibility = 'NONE';

  const { years, months } = calculateYearandMonth(date_of_birth);

  console.log(years, months);

  console.log('referral source', referral_source);

  const path = getTreatmentPath({
    interest,
    fertility_treatment,
    treatment_interest
  });

  const isMinAge = age >= 18;
  const isValidLocation = location?.toLowerCase().trim() !== 'out of province';
  const hasOHIP = ohip === 'Yes';
  const isSelfReferral = normalizeReferralSource(referral_source) === 'self';
  const isNcpPath = path === 'ncp' || path === 'fertility_check';
  const isPreservation = path === 'egg_freezing' || path === 'embryo_freezing';

  console.log('isValidLocation', isValidLocation);
  console.log('hasOHIP', hasOHIP);

  if (isSelfReferral) {
    if (isNcpPath && age >= 18 && age <= 39 && hasOHIP && isValidLocation) {
      eligibility = 'NCP';
    } else if (
      isNcpPath &&
      age >= 40 &&
      age <= 42 &&
      hasOHIP &&
      isValidLocation
    ) {
      eligibility = 'VR';
    } else if (
      isMinAge &&
      hasOHIP &&
      isValidLocation &&
      isPreservation &&
      (years < 42 || (years === 42 && months < 6))
    ) {
      eligibility = 'EF';
    } else if (
      isMinAge &&
      age < 43 &&
      hasOHIP &&
      isValidLocation &&
      path === 'ivf'
    ) {
      eligibility = 'VR';
    } else if (path === 'learn_more' && isMinAge && age < 43) {
      eligibility = 'OTHER';
    }
  } else {
    eligibility = 'MD';
  }

  return eligibility;
}

// Need to add env variables for Acuity Dev links vs Acuity Prod links
export function getAcuitylinknew(formData) {
  let acuityLink = 'NONE';

  const path = getTreatmentPath(formData);

  if (formData.eligibility === 'VR') {
    acuityLink = import.meta.env.VITE_VR_ACUITY_LINK;
  } else if (path === 'learn_more') {
    acuityLink = import.meta.env.VITE_LEARN_MORE_ACUITY_LINK;
  } else if (path === 'embryo_freezing') {
    acuityLink = import.meta.env.VITE_EMBRYO_FREEZING_ACUITY_LINK;
  } else if (path === 'egg_freezing') {
    acuityLink = import.meta.env.VITE_EF_ACUITY_LINK;
  } else if (formData.location == 'Toronto') {
    acuityLink = import.meta.env.VITE_TORONTO_NCP_ACUITY_LINK;
  } else if (formData.location == 'Simcoe') {
    acuityLink = import.meta.env.VITE_SIMCOE_NCP_ACUITY_LINK;
  } else if (formData.location == 'Ottawa') {
    acuityLink = import.meta.env.VITE_OTTAWA_NCP_ACUITY_LINK;
  }
  console.log('link', acuityLink);
  return acuityLink;
}

export function generateUniqueId() {
  const id = '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
    (
      +c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
    ).toString(16)
  );
  return `${id}.json`;
}

export function getMTlabel(formData, userTracking) {
  const { years, months } = calculateYearandMonth(
    formData.dob ?? formData.date_of_birth
  );
  const path = getTreatmentPath(formData);
  const age = formData.age;
  // Fertility preservation allows up to 42 years and 6 months.
  const overPreservationAge = years > 42 || (years === 42 && months >= 6);

  if (normalizeReferralSource(userTracking?.referral_source) === 'md') {
    return 'md referral';
  } else if (
    formData.valid_ohip === 'No' ||
    formData.location === 'Out of Province'
  ) {
    return 'private pay';
  } else if (
    (path === 'fertility_check' || path === 'ncp') &&
    (age < 18 || age > 42)
  ) {
    return 'age limit';
  } else if (age < 18) {
    // Minimum age of 18 applies to every path.
    return 'age limit';
  } else if (
    (path === 'egg_freezing' || path === 'embryo_freezing') &&
    overPreservationAge
  ) {
    return 'age limit';
  } else if (path === 'ivf' && age > 42) {
    return 'age limit';
  } else if (path === 'learn_more' && age > 42) {
    return 'age limit';
  } else {
    Sentry.captureException('No valid label found for the given condition', {
      extra: { formData }
    });
    // throw new Error('No valid label found for the given condition');
    return 'no label';
  }
}

export async function saveIntakeQuestionnaireDataNew({
  formData,
  blobPath,
  specificBlobName,
  workflow,
  userTracking
}) {
  try {
    const row = {
      landed_at: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ssZZ'),
      intake_version: 'mt_3_0',
      blob_id: specificBlobName,
      date_of_birth: formData.dob, // rename dob to date_of_birth
      FormID: 'azure_app_1',
      mt_label:
        workflow !== 'acuityFlow'
          ? getMTlabel(formData, userTracking)
          : 'acuity flow',
      ...formData, // make sure this flattens properly for CSV
      ...userTracking,
      referral_source: normalizeReferralSource(userTracking?.referral_source)
    };

    console.log('row', row);
    console.log(userTracking);
    console.log(userTracking?.referral_source ?? 'self');

    // 1. Upload to blob storage
    const uploadResponse = await axios.post(
      `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/upload-datalake`,
      {
        formData: row,
        blobPath,
        specificBlobName
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Upload successful:', uploadResponse.data);
    let appendResponse = null;

    // 2. If intake form is complete, append to CSV
    if (workflow === 'formComplete') {
      const csvFilepath = `${import.meta.env.VITE_CSV_FILE_PATH}`;
      const skipDevPrefix = true;
      const csvBlobName = `${import.meta.env.VITE_CSV_BLOB_NAME}`;

      const intakeWorkflowResponse = await axios.post(
        `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/send-email-receipt-update-md-list`,
        { file_name: uploadResponse.data.fullBlobPath },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      console.log('intake workflow triggered:', intakeWorkflowResponse.data);

      appendResponse = await axios.post(
        `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/append-datalake-csv`,
        {
          blobName: csvBlobName,
          row,
          blobPath: csvFilepath,
          skipDevPrefix
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('blob id is added to acuity link', appendResponse.data);
    }

    // 3. Route to acuity link, save specific blob name in the Acuity link
    if (workflow === 'acuityFlow') {
      const link = getAcuitylinknew(formData);
      const encodedBlobName = encodeURIComponent(specificBlobName);
      const delimiter = link.includes('?') ? '&' : '?';
      const finalLink = `${link}${delimiter}${import.meta.env.VITE_ACUITY_BLOB_NAME_FIELD}=${encodedBlobName}`; //field:16596808 is the blob name filed: env variable  VITE_ACUITY_BLOB_NAME_FIELD

      console.log('Redirecting to:', finalLink);
      window.top.location.href = finalLink;

      if (appendResponse) {
        console.log('CSV append successful:', appendResponse.data);
      }
    }

    return {
      upload: uploadResponse.data,
      ...(appendResponse && { append: appendResponse.data })
    };
  } catch (error) {
    console.error(
      'Error in saveIntakeQuestionnaireDataNew:',
      error.response?.data || error.message
    );
    throw error;
  }
}

export function useStateWithSentry(contextKey, initialValue = {}) {
  const [state, setState] = useState(initialValue);

  const setStateAndSentry = newValue => {
    setState(newValue);
    // grab the active hub and configure its scope:
    Sentry.setContext(contextKey, newValue);
  };

  return [state, setStateAndSentry];
}

const reiWeights = {
  pr: 5,
  ra: 5,
  ag: 3,
  sm: 2
};

function pickWeighted(weights) {
  const total = Object.values(weights).reduce((a, b) => a + b, 0);
  let r = Math.random() * total;
  for (const [key, weight] of Object.entries(weights)) {
    if (r < weight) return key;
    r -= weight;
  }
}
 // -------------------------------------------------------------------------------------------------------------------
 function getMonth(offset = 0) {
  const date = new Date();
  return new Date(date.getFullYear(), date.getMonth() + offset, 1)
    .toISOString()
    .slice(0, 7);
}
async function fetchAcuityAvailability(month) {
  const response = await axios.get(
    `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/api/availability`,
    {
      params: { month }
    }
  );

  return response.data;
}
 // -------------------------------------------------------------------------------------------------------------------

// const referDoctors = {
//   pr: 'Paul Robb',
//   ra: 'Rebecca Arthur',
//   ag: 'Ashley Gilman',
//   sm: 'Shannon Moore'
// };

export async function triggerMdreferralWorkflow({
  formData,
  blobPath,
  specificBlobName
}) {
  try {
    //0. assign nextRei value is next REI is selected
    let nextRei = null;
    //---------------------------------------------------------------------------------------------------------------s
    let combinedAvailability = [];
    let attempts = 0;
    let MAX_REI_ATTEMPTS = 10;
    //---------------------------------------------------------------------------------------------------------------e
    if (formData.doctor_calendar === 'next_rei') {
      //nextRei = pickWeighted(reiWeights); // e.g. "pr", "ra", etc.
      //---------------------------------------------------------------------------------------------------------------s
      while (attempts < MAX_REI_ATTEMPTS) {
        attempts++;
        nextRei = pickWeighted(reiWeights);

        if (nextRei !== "sm") {
          break; // accept
        }

        const currentMonth = getMonth(0);
        const nextMonth = getMonth(1);

        const [currentAvail, nextAvail] = await Promise.all([
          fetchAcuityAvailability(currentMonth),
          fetchAcuityAvailability(nextMonth)
        ]);

        combinedAvailability = [
          ...(currentAvail || []),
          ...(nextAvail || [])
        ];

        if (combinedAvailability.length > 0) {
          break;
        }

        console.log(`SM has no availability, retrying (${attempts})`);
      }

      if (!nextRei) {
        throw new Error("Failed to select an REI");
      }

      if (attempts === MAX_REI_ATTEMPTS && nextRei === "sm" && combinedAvailability.length === 0) {
        console.warn("SM never had availability after max retries");
      }
      //---------------------------------------------------------------------------------------------------------------e
      console.log('Chosen REI doctor for this batch:', nextRei);
    }
    const row = {
      landed_at: DateTime.local().toFormat('yyyy-MM-dd HH:mm:ssZZ'),
      blob_id: specificBlobName,
      FormID: 'azure_app_1',
      ...formData, // make sure this flattens properly for CSV
      ...(nextRei && { nextRei })
    };

    console.log('row', row);

    // 1. Upload to blob storage
    const uploadResponse = await axios.post(
      `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/upload-datalake`,
      {
        formData: row,
        blobPath,
        specificBlobName
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('Upload successful:', uploadResponse.data);
    let appendResponse = null;
    let appendResponsecurated = null;

    // 2. append to md_referral.csv and md_referral_curated.csv

    const csvFilepath = `${import.meta.env.VITE_MD_CSV_FILE_PATH}`;
    const skipDevPrefix = true;
    const csvBlobName = `${import.meta.env.VITE_MD_CSV_BLOB_NAME}`;
    const csvcuratedBlobName = `${import.meta.env.VITE_MD_CSV_CURATED_BLOB_NAME}`;

    appendResponse = await axios.post(
      `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/append-datalake-csv`,
      {
        blobName: csvBlobName,
        row,
        blobPath: csvFilepath,
        skipDevPrefix
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log('md_referral csv is updated', appendResponse.data);

    appendResponsecurated = await axios.post(
      `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/append-datalake-csv`,
      {
        blobName: csvcuratedBlobName,
        row,
        blobPath: csvFilepath,
        skipDevPrefix
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    console.log(
      'md_referral_curated csv is updated',
      appendResponsecurated.data
    );

    // 3. Trigger text message to patients

    const smsResponses = [];

    for (const rawNumber of Array.isArray(formData.patient_phone_number)
      ? formData.patient_phone_number
      : [formData.patient_phone_number]) {
      const cleanedNumber = cleanPhoneNumber(rawNumber);

      try {
        const smsResponse = await axios.post(
          `${import.meta.env.VITE_APP_VENNA_BACKEND_API_BASE_URL}/send-sms`,
          {
            to: cleanedNumber,
            formData: {
              ...formData,
              ...(nextRei && { nextRei }) // pass key to backend
            }
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        console.log(`SMS sent to ${cleanedNumber}:`, smsResponse.data);
        smsResponses.push({
          number: cleanedNumber,
          success: true,
          data: smsResponse.data
        });
      } catch (smsError) {
        console.error(
          `Failed to send SMS to ${cleanedNumber}:`,
          smsError.response?.data || smsError.message
        );
        smsResponses.push({
          number: cleanedNumber,
          success: false,
          error: smsError.response?.data || smsError.message
        });
      }
    }

    return {
      upload: uploadResponse.data,
      ...(appendResponse && { append: appendResponse.data }),
      smsResponses
    };
  } catch (error) {
    console.error(
      'Error in MD Referral data:',
      error.response?.data || error.message
    );
    throw error;
  }
}

function cleanPhoneNumber(input) {
  // If input is an array, clean each number recursively
  if (Array.isArray(input)) {
    return input
      .filter(num => num && String(num).trim() !== '') // remove empty/undefined
      .map(num => cleanPhoneNumber(num));
  }

  // Handle single number case
  console.log('Raw input:', input);
  let digits = String(input).replace(/\D/g, '');
  console.log('Digits only:', digits);

  if (digits.length === 10) {
    digits = '+1' + digits;
  } else if (!digits.startsWith('+') && digits.length > 0) {
    digits = '+' + digits;
  }

  console.log('Cleaned number:', digits);
  return digits;
}
